import React from 'react';
import { withTranslation } from 'react-i18next';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { YcProject } from '../YcProject';

// styles
import './ycFullProjects.scss';

import imgFaubourg from '@/assets/images/c-full-projects/head-faubourg.png';
import imgRoad from '@/assets/images/c-full-projects/head-road.png';
import imgBic from '@/assets/images/c-full-projects/head-bic.png';
import imgDether from '@/assets/images/c-full-projects/head-dether.png';
import imgXXE from '@/assets/images/c-full-projects/head-xxe.png';
import imgIsho from '@/assets/images/c-full-projects/head-isho.png';
import imgIrm from '@/assets/images/c-full-projects/head-irm.png';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

export const YcFullProjects = withTranslation(['about-us'])(
  class YcFullProjectsClass extends React.PureComponent {
    projects = [
      {
        img: imgFaubourg,
        title: 'Le Faubourg',
        desc: 'Conception du nouveau site internet du restaurant Le Faubourg.',
      },
      {
        img: imgRoad,
        title: 'Hit the road',
        desc: 'Conception de la nouvelle identité graphique de la plateforme Hit the road, App et site web.',
      },
      {
        img: imgBic,
        title: 'Shop BIC',
        desc: 'Développement d’une plateforme de personnalisation de briquets.',
      },
      {
        img: imgDether,
        title: 'Dether.io',
        desc:
          'Conception d’une plateforme de création de wallet pour l’achat et vente de cryptomonnaies.',
      },
      {
        img: imgXXE,
        title: 'XXE',
        desc: 'Création de la plateforme XXE qui met en relation des travailleurs indépendants (freelances) et des clients.',
      },
      {
        img: imgIsho,
        title: 'Isho Immo',
        desc:
          'Conception et développement du site internet (espace client et administrateur) et de l’identité graphique de l’agence.',
      },
      {
        img: imgIrm,
        title: 'Plateforme IRM',
        desc:
          'Elaboration d’un outil intranet s’intégrant dans un écosystème et répondant à des besoins spécifiques.',
      },
    ];
    constructor(props) {
      super();
    }

    render() {
      return (
        <div className="c-full-projects">
          <div className="content">
            <h2>Nos <font color='#47abff'>projets</font></h2>
            <p>
              Qu’il s’agisse de webdesign, d’application mobile, d’intranet ou d’une interface utilisateur spécifique, nos experts sont à
              votre écoute pour répondre rapidement et efficacement à votre demande et à celle de vos clients.
            </p>
            <div className="row project-list">
              <div className="col-xl-4 col-lg-6 col-12">
                <AnchorLink offset="0px" href="#contact-us">
                  <button className="btn btn-outline-primary">
                    <FontAwesomeIcon icon={faPlus} className="icon mb-2" />
                    <p className="btn-text inline">Ajouter mon projet</p>
                  </button>
                </AnchorLink>
              </div>
              {this.projects.map((project, index) => (
                <div className="col-xl-4 col-lg-6 col-12 swipe-content" key={index}>
                  <YcProject project={project} />
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
  },
);
